import { Component, Input } from '@angular/core';
import { NbDialogRef,NbDialogService, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';
import { ApiService } from '../../shared/api.service';
import { RegisteredComponent } from './registered.component';
import { config } from '../../../../config';

@Component({
    selector: 'nb-dialog',
    template: `
       <nb-card class="col-md-6 offset-md-3" [style.height.px]="600">
        <nb-card-header id="header" style="text-align: center">Please review and consider the following before continuing <nb-action icon="ion-close" style="float: right;" (click)="close()"></nb-action></nb-card-header>
           <nb-card-body>
        <nb-alert status="danger" closable (close)="onClose()" *ngIf="messagealertflag == 1">
                Email Already Exists !!!!
        </nb-alert> 
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-11" >
                <nb-checkbox status="success" value="true" disabled>
                Solapur University may communicate with me by mail, email, phone, whatsapp or text message about my account and other information relevant to the application process.
                </nb-checkbox>
            </div>
        </div><br>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-11">
                <nb-checkbox status="success" value="true" disabled>
                        By checking this box, I represent that (i) I am age 13 or older and (ii) I have read, understood and agreed to the terms and conditions of the Terms of Use and Privacy Policy (unless I am over the age of 13 but under the age of 18, in which case, my parent or legal guardian has also read, understood and agreed to the terms and conditions of the Privacy Policy and Terms of Use sections).
                </nb-checkbox>
            </div>
            
        </div><br>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-11">
                <nb-checkbox status="success" value="true" disabled>
                    I accept that (I) Fees paid is not refundable  And (II) All the information filled by me is true.
                </nb-checkbox>
            </div>
		</div><br>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-11">
                <nb-checkbox status="success" value="true" disabled>
                Solapur University website uses small files stored on your computer, known as cookies, that help us remember your settings and ensure the website works properly. By continuing, I am agreeing to The Solapur University's use of cookies.
                </nb-checkbox>
            </div>
        </div> 	
        <div class="col-lg-11"*ngIf="alertflag == 1" id ="alert" >
            <h5 style="color:red">You should agree terms 2, 3 and 4.</h5>
        </div>
		  
      </nb-card-body>
	  <nb-card-footer>
	  <div class="row">
	  <div class="offset-lg-4"></div><button nbButton [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="xlarge"  status="success"  (click)="Register()" class="col-lg-4">Register</button>
	  
	 </div> 
     <p-dialog [(visible)]="displyaMandatoryDoc" [modal]="true" [responsive]="true" [style]="{width: '1050px', height:'750px'}" (onHide)="closeDialog()">
     <nb-card  style="width:1050px; height:750px;">
       <nb-card-body>
         <video id="video1" src="{{serverUrl}}/api/upload/video/mandatory_doc.mp4" controls style="width: 1000px;height: 750px;"></video>
       </nb-card-body>
     </nb-card>
   </p-dialog>          
        </nb-card-footer>
    </nb-card>
    `,
    })
    export class TermsComponent {
        @Input() FirstName:string;
        @Input() LastName:string;
        @Input() userName:string;
        @Input() Gender:string;
        @Input() inputprn:string;
        @Input() userEmail:string;
        @Input() userPassword:string;
        @Input() userContactNo:any;
        @Input() aadhar:any;
        @Input() course_name:any; 
        @Input() userCountryCode: any;
        @Input() stud_fathernameCtrl: any;
        @Input() degree_type:any;

        loading=false;
        Condition;
        Condition3;
        Condition4;
        Condition5;
        alertflag=0;
        messagealertflag=0;
        alert;
        user_id: any;
        displyaMandatoryDoc: boolean = false;
        serverUrl = config.serverUrl;
        constructor(protected ref: NbDialogRef<TermsComponent>,
            private router : Router,
            private dialogService: NbDialogService,
            private toasterService: NbToastrService,
            protected api : ApiService) {
        }

        Register(){
            this.Condition=this.Condition3;
            var register_data ={
                FirstName :this.FirstName,
                LastName : this.LastName,
                userName : this.userName,
                Gender : this.Gender,
                inputprn : this.inputprn,
                userEmail : this.userEmail,
                userPassword : this.userPassword,
                userContactNo : this.userContactNo,
                aadhar : this.aadhar,
                course_name : this.course_name,
                userCountryCode : this.userCountryCode,
                stud_fathernameCtrl: this.stud_fathernameCtrl,
                degree_type :this.degree_type
            }

            
            // if(this.Condition != true || this.Condition4 != true || this.Condition5 != true){
            //         this.alertflag=1
            // }else{
                this.loading = true;
                this.alertflag=0
                this.api.RegisterValues(register_data)
                    .subscribe(
                    (data: any) => {
                        if(data['status'] == 200){
                            this.messagealertflag = 0;
                            this.user_id=data['data'];
                            this.loading = false;
                            this.ref.close(this.user_id);
                            this.toasterService.success('otp send successfully!!','Success',{duration: 3000});
                            this.dialogService.open(RegisteredComponent, {
                                context: {
                                    email: this.userEmail,
                                    password:this.userPassword,
                                    userCountryCode: this.userCountryCode,
                                    userContactNo : this.userContactNo,
                                    user_id  : this.user_id
                                },
                            });

                        }else if(data['status'] == 400){
                            this.messagealertflag = 1;                               
                            console.error("error 400 ");
                        }else{
                        }       
                        err => console.error(err)
                    });
            // }
        }

        onClose() {
            this.messagealertflag = 0;
            this.ref.close();
        }

        close(){
            this.ref.close();
        }

        // videopopup(){
        //     this.displyaMandatoryDoc=true
        // }
        closeDialog(){
            this.dialogService.open(RegisteredComponent, {
                context: {
                    email: this.userEmail,
                    password:this.userPassword,
                    userCountryCode: this.userCountryCode,
                    userContactNo : this.userContactNo,
                    user_id  : this.user_id
                },
            });
            this.ref.close(this.user_id)
        }
    }